import { PropsWithChildren } from "react";

import styles from "@components/fieldsNative/SearchInputWrapper.module.css";
import Icon from "@components/text/Icon";

type Props = PropsWithChildren<{
  className?: string;
}>;

const SearchInputWrapper = ({ children, className }: Props) => {
  const wrapperClasses = [styles.inputWrapper];
  if (className) wrapperClasses.push(className);

  return (
    <div className={wrapperClasses.join(" ")}>
      <div className={styles.relativeWrapper}>
        <div className={styles.iconContainer}>
          <Icon color="white" icon="search" />
        </div>
        {children}
      </div>
    </div>
  );
};

export default SearchInputWrapper;
